export default {"src":"/org/_next/static/media/play-store.e2aa392c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};